import {
    isOrderItemBookable_V1,
    isOrderItemBuyable_V1,
    isOrderItemGiftCard_V1,
    isOrderItemVoucher_V1,
    isOrderItem_V1,
} from "./is-order-item-v1";
import {
    isOrderItemAccommodationRateItem_V2,
    isOrderItemAccommodation_V2,
    isOrderItemBookableQuantity_V2,
    isOrderItemBookable_V2,
    isOrderItemBuyable_V2,
    isOrderItemDiscount_V2,
    isOrderItemGiftCard_V2,
    isOrderItemOptional_V2,
    isOrderItemUsedGiftCard_V2,
    isOrderItemVoucher_V2,
    isOrderItem_V2,
} from "./is-order-item-v2";
import type {
    OrderItem,
    OrderItemBookable,
    OrderItemBuyable,
    OrderItemVoucher,
} from "./order-item";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItem = (item: any): item is OrderItem => {
    return isOrderItem_V2(item) || isOrderItem_V1(item);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemBookable = (item: any): item is OrderItemBookable => {
    return isOrderItemBookable_V2(item) || isOrderItemBookable_V1(item);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemBuyable = (item: any): item is OrderItemBuyable => {
    return isOrderItemBuyable_V2(item) || isOrderItemBuyable_V1(item);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemVoucher = (item: any): item is OrderItemVoucher => {
    return isOrderItemVoucher_V2(item) || isOrderItemVoucher_V1(item);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOrderItemGiftCard = (item: any): item is OrderItemVoucher => {
    return isOrderItemGiftCard_V2(item) || isOrderItemGiftCard_V1(item);
};

const isOrderItemOptional = isOrderItemOptional_V2;
const isOrderItemBookableQuantity = isOrderItemBookableQuantity_V2;
const isOrderItemAccommodationRateItem = isOrderItemAccommodationRateItem_V2;
const isOrderItemAccommodation = isOrderItemAccommodation_V2;
const isOrderItemUsedGiftCard = isOrderItemUsedGiftCard_V2;
const isOrderItemDiscount = isOrderItemDiscount_V2;

export {
    isOrderItem,
    isOrderItemAccommodation,
    isOrderItemAccommodationRateItem,
    isOrderItemBookable,
    isOrderItemBookableQuantity,
    isOrderItemBuyable,
    isOrderItemDiscount,
    isOrderItemGiftCard,
    isOrderItemOptional,
    isOrderItemUsedGiftCard,
    isOrderItemVoucher,
};
